export enum CadastroDocumentoTipo {
    CONTRATO = 'CONTRATO',
    PROCURACAO = 'PROCURACAO',
    COMPROVANTE_DE_RENDA = 'COMPROVANTE_DE_RENDA',
    DECLARACAO_VIZINHO = 'DECLARACAO_VIZINHO',
    DECLARACAO_DOMICILIO = 'DECLARACAO_DOMICILIO',
    DECLARACAO_AUTONOMO = 'DECLARACAO_AUTONOMO',
    DECLARACAO_QUESTIONARIO_JURIDICO = 'DECLARACAO_QUESTIONARIO_JURIDICO'
}
